import { version } from '../../package.json'

export default {
  device: {
    "connected": false,
    "reconnected": false,
    "bootloaderMode": false,
    "firmwareVersion": "0.0.0",
    "previousFirmwareVersion": "0.0.0",
    "bootloaderVersion": "0.0.0",
    "availableFirmware": {url: "firmware/mallet-station-v1.1.0.syx", version: "1.1.0"},
    "updatingFirmware": false,
    "presetButtonsMode": [0, 0, 0, 0],
    "crosstalkThreshold": 5,
    "globalThreshold": '1.00',
    "legacyFirmwareVersion": "1.0.4"
  },
  editor: {
    "editorVersion": version,
    "beta": false,
    "availableEditor": {version: '0.0.0'},
    "editorUpdateAvailable": false,
    "updatingEditor": false,
    "downloadProgress": 0,
    "minimumCompatibleVersion": "1.1.0", // FW

    "networkConnection": false,

    "statusMessage": 'disconnected',
    "barInfoActive": false,
    "barInfo": '',

    "devicePresetsLoaded": false,
    "factoryPresetsLoaded": false,
    "userPresetsLoaded": false,
    "initialPresetLoaded": false,
    "selectedPreset": 'factory-0',
    "destination": 1,

    "userPresetDialogOpen": false,
    "userPresetName": '',
    "revertablePreset": false,

    "selectedGapCap": -1,
    "selectedBar": -1,
    "selectedLearnBar": 0,
    "errorLearnBars": [],
    "selectedSplit": 0,
    "selectedButton": 0,
    "selectedFader": 0,
    "selectedPedal": 0,
    "selectedVelocityCurve": -1,
    "selectedUserCurve": 7,

    "preferencesOpen": false,
    "learnModeOpen": false,
    "velocityCurvesOpen": false,
    "presetsImportRenameDialogOpen": false,
    "unsavedChangesOpen": false,

    "learnModeRecording": false,
    "learnModeAuto": false,
    "learnModeUseSounds": true,
    "learnModeStrikeType": 'soft',
    "learnModeStrikeCount": 0,
    "learnModeTourOpen": false,
    "learnModeComplete": false,

    "sensitivityPreset": 'default',

    "importedPresets": {
      presets: [],
      duplicates: {},
      renamed: {}
    }
  },
  currentPreset: {
    "name":"_initPreset_",
    "gain":"1.00",
    "version":4,
    "octave":0,
    "lowNote":3,
    "gapCaps":{
       "notes":[80, 81, 82, 83, 84, 85],
       "curve":0,
       "channel":9
    },
    "splits":[
      {
         "bar":-1,
         "curve":0,
         "channel":0
      },
      {
         "bar":43,
         "curve":0,
         "channel":1
      }
    ],
    "buttons":[
      {
         "note":-1,
         "cc":-1,
         "bankMSB":-1,
         "bankLSB":-1,
         "patch":-1,
         "channel":0
      },
      {
         "note":-1,
         "cc":-1,
         "bankMSB":-1,
         "bankLSB":-1,
         "patch":-1,
         "channel":0
      },
      {
         "note":-1,
         "cc":-1,
         "bankMSB":-1,
         "bankLSB":-1,
         "patch":-1,
         "channel":0
      },
      {
         "note":-1,
         "cc":-1,
         "bankMSB":-1,
         "bankLSB":-1,
         "patch":-1,
         "channel":0
      }
    ],
    "faders":[
      {
         "mode":1,
         "cc":20,
         "channel":0
      },
      {
         "mode":1,
         "cc":1,
         "channel":0
      },
      {
         "mode":0,
         "cc":7,
         "channel":0
      }
    ],
    "playParams":{
       "playMode":0,
       "noteOnTime":90,
       "dampThreshold":5
    },
    "pedals":[
      {
         "mode":0,
         "cc":64,
         "channel":0
      },
      {
         "mode":1,
         "cc":64,
         "channel":0
      },
      {
         "mode":1,
         "cc":7,
         "channel":0
      }
    ]
  },
  presets: {
    device: [],
    user: [],
    factory: []
  },
  userCurves: {
    'usercurve-0': Array.from(Array(127).keys()),
    'usercurve-1': Array.from(Array(127).keys()),
    'usercurve-2': Array.from(Array(127).keys()),
    'usercurve-3': Array.from(Array(127).keys())
  },
  learnMode: {
    records: Array.from(Array(43)).fill(null),
    completedStrikes: Array.from(Array(43)).fill(0),
    learnedAverageLows: Array.from(Array(43)).fill(null),
    learnedAverageHighs: Array.from(Array(43)).fill(null),
    tares: [...Array(43).fill(0)],
    averageLows: [...Array(43).fill(0)],
    averageHighs: [...Array(43).fill(0)],
    lowMults: [...Array(43).fill(0)],
    highMults: [...Array(43).fill(0)]
  },
  editorPreferences: {
    uiSync: true,
    showTooltips: true,
    autohideSliders: false,
    showLearnModeTour: true
  }
}
